import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_warning_triangles.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = {
  class: "border border-gray-lp-1400 w-full",
  style: {"border-radius":"20px"}
}
const _hoisted_2 = {
  class: "flex items-center w-full ml-auto justify-between gap-x-6 pr-4 font-montserrat px-5 py-2.5 bg-white",
  style: {"border-top-left-radius":"20px","border-top-right-radius":"20px"}
}
const _hoisted_3 = { class: "text-gray-lp-300 font-semibold text-base" }
const _hoisted_4 = { class: "text-gray-lp-300 text-xl font-semibold" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "w-full flex items-stretch text-gray-lp-300 metric-container bg-gray-lp-1000 px-5 py-2.5" }
const _hoisted_7 = { class: "flex flex-row w-1/3" }
const _hoisted_8 = { class: "flex flex-col gap-1 pr-8 flex-1" }
const _hoisted_9 = { class: "text-sm tracking-wide" }
const _hoisted_10 = { class: "text-xl font-semibold text-black-lp-100" }
const _hoisted_11 = { class: "flex flex-row w-1/3" }
const _hoisted_12 = { class: "flex flex-col gap-1 px-8 flex-1 border-l border-gray-lp-1400" }
const _hoisted_13 = { class: "text-sm tracking-wide" }
const _hoisted_14 = { class: "text-xl font-semibold text-black-lp-100" }
const _hoisted_15 = { class: "flex flex-col gap-1 px-8 flex-1 border-l border-gray-lp-1400" }
const _hoisted_16 = { class: "text-sm tracking-wide" }
const _hoisted_17 = {
  class: "w-full flex items-stretch text-gray-lp-300 metric-container  px-5 py-2.5 bg-white",
  style: {"border-bottom-left-radius":"1.25rem","border-bottom-right-radius":"1.25rem"}
}
const _hoisted_18 = { class: "flex flex-row w-2/3 gap-6" }
const _hoisted_19 = { class: "w-1/5" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_22 = { class: "text-sm tracking-wide" }
const _hoisted_23 = { class: "text-xl font-semibold text-black-lp-100" }
const _hoisted_24 = { class: "w-1/6" }
const _hoisted_25 = { class: "flex flex-col" }
const _hoisted_26 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_27 = { class: "text-sm tracking-wide" }
const _hoisted_28 = { class: "text-xl font-semibold text-black-lp-100" }
const _hoisted_29 = { class: "w-1/4" }
const _hoisted_30 = { class: "flex flex-col gap-2" }
const _hoisted_31 = {
  key: 0,
  class: "flex flex-row items-center text-blue-lp-700 text-xs gap-1"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_33 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_34 = { class: "text-sm tracking-wide" }
const _hoisted_35 = { class: "text-xl font-semibold text-black-lp-100" }
const _hoisted_36 = { class: "flex flex-col gap-1 px-8 flex-1 " }
const _hoisted_37 = { class: "text-sm tracking-wide" }
const _hoisted_38 = { class: "flex flex-row items-start gap-x-4" }
const _hoisted_39 = {
  key: 0,
  class: "flex flex-grow flex-col items-center gap-y-1"
}
const _hoisted_40 = { class: "text-sm tracking-wide text-gray-lp-500" }
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "loading-dots" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createVNode("span")
], -1)
const _hoisted_42 = {
  key: 0,
  class: "text-red-lp-2000 text-12px flex items-center gap-x-1 mt-1"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-3.5 max-w-none",
  alt: "exclamation triangle red"
}, null, -1)
const _hoisted_44 = { class: "flex flex-col gap-1 px-8 flex-1 border-l border-gray-lp-1400" }
const _hoisted_45 = { class: "text-sm tracking-wide" }
const _hoisted_46 = {
  key: 0,
  class: "text-red-lp-2000 text-12px flex items-center gap-x-1 mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_2, [
        _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("cargo.summary.reweighWeightTitle")), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.totalStt), 1),
          _createTextVNode(" STT (" + _toDisplayString(_ctx.totalPieces) + " " + _toDisplayString(_ctx.$t("cargo.labels.pieces")) + ") ", 1)
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("cargo.labels.grossWeightReweigh")), 1),
            _createVNode("span", _hoisted_10, _toDisplayString(`${_ctx.convertDecimal(_ctx.totalGrossWeights)} kg`), 1)
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("cargo.labels.volumeWeightReweigh")), 1),
            _createVNode("span", _hoisted_14, _toDisplayString(`${_ctx.convertDecimal(_ctx.totalVolumeWeights)} kg`), 1)
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("cargo.labels.chargeableWeightReweigh")), 1),
          _createVNode("span", {
            class: ["text-xl font-semibold ", [
              { 'text-black-lp-100': _ctx.isSummaryOnly },
              { 'text-blue-lp-700': !_ctx.isSummaryOnly }
            ]]
          }, _toDisplayString(`${_ctx.convertDecimal(_ctx.chargeableWeight)} kg`), 3)
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            (!_ctx.isSummaryOnly)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: _ctx.$t('cargo.labels.totalCargoWeight')
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_20, [
                      _createVNode(_component_lp_input, {
                        "data-testid": "cargo-weight-input-gross",
                        modelValue: _ctx.actualTotalCargoGrossWeight,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.actualTotalCargoGrossWeight = $event)),
                        suffix: "Kg",
                        onChange: _ctx.onChangeTotalCargoGrossWeight,
                        format: _ctx.formatFloat,
                        error: _ctx.isErrorGrossWeight,
                        isErrorIconCaption: false,
                        isErrorIconInput: false
                      }, null, 8, ["modelValue", "onChange", "format", "error"]),
                      _withDirectives(_createVNode("p", {
                        class: "text-xs text-red-lp-2000",
                        style: {"line-height":"100%","letter-spacing":"-2%"}
                      }, _toDisplayString(_ctx.$t("cargo.messages.weightExceededLimit")), 513), [
                        [_vShow, _ctx.isErrorGrossWeight]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : (_openBlock(), _createBlock("div", _hoisted_21, [
                  _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("cargo.labels.grossWeightCargo")), 1),
                  _createVNode("span", _hoisted_23, _toDisplayString(`${_ctx.convertDecimal(_ctx.form.actualTotalCargoGrossWeight)} kg`), 1)
                ]))
          ]),
          _createVNode("div", _hoisted_24, [
            (!_ctx.isSummaryOnly)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: _ctx.$t('Koli kargo')
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_25, [
                      _createVNode(_component_lp_input, {
                        onChange: _ctx.onChangeTotalPieces,
                        isErrorIconInput: false,
                        modelValue: _ctx.form.actualTotalSTTPieces,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.actualTotalSTTPieces = $event)),
                        format: _ctx.formatNoDecimal,
                        error: _ctx.isErrorMaxPieces,
                        isErrorIconCaption: false
                      }, null, 8, ["onChange", "modelValue", "format", "error"]),
                      _withDirectives(_createVNode("p", {
                        class: "text-xs text-red-lp-2000",
                        style: {"line-height":"100%","letter-spacing":"-2%"}
                      }, " - " + _toDisplayString(_ctx.$t("cargo.messages.piecesExceededLimit")), 513), [
                        [_vShow, _ctx.isErrorMaxPieces]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : (_openBlock(), _createBlock("div", _hoisted_26, [
                  _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("cargo.labels.cargoPieces")), 1),
                  _createVNode("span", _hoisted_28, _toDisplayString(_ctx.form.actualTotalSTTPieces), 1)
                ]))
          ]),
          _createVNode("div", _hoisted_29, [
            (!_ctx.isSummaryOnly)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: _ctx.$t('cargo.labels.cargoDimension'),
                  suffix: "P x L x T"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_30, [
                      _createVNode(_component_InputDimension, {
                        class: "my-1.5",
                        onChange: _ctx.onChangeDimension,
                        length: _ctx.form.actualDimension.length,
                        "onUpdate:length": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.actualDimension.length = $event)),
                        width: _ctx.form.actualDimension.width,
                        "onUpdate:width": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.actualDimension.width = $event)),
                        height: _ctx.form.actualDimension.height,
                        "onUpdate:height": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.actualDimension.height = $event)),
                        withIcon: false,
                        format: _ctx.formatDimension
                      }, null, 8, ["onChange", "length", "width", "height", "format"]),
                      (!_ctx.isDimensionChanged)
                        ? (_openBlock(), _createBlock("div", _hoisted_31, [
                            _hoisted_32,
                            _createVNode("div", null, _toDisplayString(_ctx.$t("cargo.messages.editDimensionIfChanged")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : (_openBlock(), _createBlock("div", _hoisted_33, [
                  _createVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("cargo.labels.cargoDimension")), 1),
                  _createVNode("span", _hoisted_35, _toDisplayString(`${_ctx.convertDecimal(
                    _ctx.form.actualDimension.length
                  )} x ${_ctx.convertDecimal(
                    _ctx.form.actualDimension.width
                  )} x ${_ctx.convertDecimal(_ctx.form.actualDimension.height)} cm`), 1)
                ]))
          ]),
          _createVNode("div", _hoisted_36, [
            _createVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("cargo.labels.volumeWeightCargo")), 1),
            _createVNode("div", _hoisted_38, [
              _createVNode("span", {
                class: ["text-xl font-semibold", [
                  { 'text-red-lp-2000': _ctx.isErrorVolumeWeight && !_ctx.isSummaryOnly },
                  { 'text-blue-lp-700': !_ctx.isErrorVolumeWeight && !_ctx.isSummaryOnly },
                  { 'text-black-lp-100': _ctx.isSummaryOnly }
                ]]
              }, _toDisplayString(`${_ctx.convertDecimal(Math.round(_ctx.form.actualTotalCargoVolumeWeight))} kg`), 3),
              (_ctx.isLoadingCalculate)
                ? (_openBlock(), _createBlock("div", _hoisted_39, [
                    _createVNode(_component_Spinner, {
                      class: "w-10 h-10 animate-spin",
                      color: "#A7A8AA"
                    }),
                    _createVNode("span", _hoisted_40, [
                      _createTextVNode(_toDisplayString(_ctx.$t("cargo.messages.calculating")), 1),
                      _hoisted_41
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isErrorVolumeWeight)
              ? (_openBlock(), _createBlock("div", _hoisted_42, [
                  _hoisted_43,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("cargo.messages.volumeExceededLimit")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_44, [
          _createVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("cargo.labels.chargeableWeightCargo")), 1),
          _createVNode("span", {
            class: ["text-xl font-semibold", [
              {
                'text-red-lp-2000': _ctx.errorDisputeCargo.message && !_ctx.isSummaryOnly
              },
              {
                'text-blue-lp-700': !_ctx.errorDisputeCargo.message && !_ctx.isSummaryOnly
              },
              { 'text-black-lp-100': _ctx.isSummaryOnly }
            ]]
          }, _toDisplayString(`${_ctx.convertDecimal(_ctx.actualChargeableWeight)} kg`), 3),
          (_ctx.errorDisputeCargo.message)
            ? (_openBlock(), _createBlock("div", _hoisted_46, [
                _createTextVNode(_toDisplayString(_ctx.errorDisputeCargo.message) + " ", 1),
                (_ctx.errorDisputeCargo.tooltip)
                  ? (_openBlock(), _createBlock(_component_TooltipV2, {
                      key: 0,
                      description: _ctx.errorDisputeCargo.tooltip,
                      iconColor: "text-red-lp-100"
                    }, null, 8, ["description"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}